import { useId, type JSX } from 'react';

import {
  PLATFORM_ROLE_DESCRIPTIONS,
  PLATFORM_ROLE_LABELS,
  PLATFORM_ROLES,
  type PlatformAdminRole,
} from '@/lib/permissions';

import styles from '../pages/AdminsPage.module.scss';

interface Props {
  value: PlatformAdminRole | null;
  onChange: (role: PlatformAdminRole) => void;
  legend?: string;
}

/** OS-1717 — elección de rol con lo que cada uno puede hacer (descripción, no la matriz). */
export function RoleChoice({ value, onChange, legend = 'Rol' }: Props): JSX.Element {
  const name = useId();
  return (
    <fieldset className={styles.roles}>
      <legend className={styles.legend}>{legend} *</legend>
      {PLATFORM_ROLES.map((role) => (
        <label key={role} className={value === role ? styles.roleOptionActive : styles.roleOption}>
          <input
            type="radio"
            name={name}
            value={role}
            checked={value === role}
            onChange={() => onChange(role)}
          />
          <span>
            <span className={styles.roleName}>{PLATFORM_ROLE_LABELS[role]}</span>
            <span className={styles.roleDescription}>{PLATFORM_ROLE_DESCRIPTIONS[role]}</span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
